import { render, staticRenderFns } from "./OpenEndedContent.vue?vue&type=template&id=41f1ec6a&scoped=true"
import script from "./OpenEndedContent.vue?vue&type=script&lang=js"
export * from "./OpenEndedContent.vue?vue&type=script&lang=js"
import style0 from "./OpenEndedContent.vue?vue&type=style&index=0&id=41f1ec6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1ec6a",
  null
  
)

export default component.exports